import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DatasetIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dataset"}/>
}
